import moment from "moment";
import React from "react";
import { useDispatch } from "react-redux";

import { useLocalStorage } from "../../hooks";

import { useLocation, useNavigate } from "react-router-dom";
import DeleteDialog from "../../components/DeleteDialog";
import { TwButton, TwContainer, TwMainLayout } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForBookings } from "../../utils/confighelpers";
import { displayAvailablePaymentMethods } from "../../utils/constants";
import ActionPopover from "./ActionPopover";
import { useTranslation } from "react-i18next";

export default function EventBookingDetails({ navigation }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userToken] = useLocalStorage("userToken");
  const [bookingInfo, setBookingInfo] = React.useState({});
  const [delDialogOpen, setDelDialogOpen] = React.useState(false);

  const fetchBookingsDetails = async () => {
    const config = {
      method: "get",
      url: `${getUrlForBookings()}getBookingDetails/${location.state.bookingId}`,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        setBookingInfo(request.data.data);
      }
    }
    dispatch(setGlobalLoading(false));
  };

  React.useEffect(() => {
    (async () => {
      dispatch(setGlobalLoading(true));
      await fetchBookingsDetails();
      dispatch(setGlobalLoading(false));
    })();
  }, []);

  const calculateBoughtTickets = () => {
    let totalBookedTickets = 0;

    if (bookingInfo && bookingInfo?.ticketsBought?.length) {
      bookingInfo?.ticketsBought.forEach((item) => {
        totalBookedTickets = totalBookedTickets + parseInt(item.bookingQty);
      });
    }

    return totalBookedTickets;
  };

  const calculateBoughtAddons = () => {
    let totalBookedAddons = 0;

    if (bookingInfo && bookingInfo?.addonsBought?.length) {
      bookingInfo?.addonsBought.forEach((item) => {
        totalBookedAddons = totalBookedAddons + parseInt(item.bookingQty);
      });
    }

    return totalBookedAddons;
  };

  const calculateTotalPrice = () => {
    let priceToConsumer = 0;
    let serviceFees = 0;

    if (bookingInfo?.totalPriceToConsumer) {
      return parseFloat(bookingInfo?.totalPriceToConsumer || 0).toFixed(2);
    } else if (bookingInfo?.amount) {
      return parseFloat(bookingInfo?.amount || 0).toFixed(2);
    } else {
      if (bookingInfo && bookingInfo?.ticketsBought?.length) {
        bookingInfo?.ticketsBought.forEach((item) => {
          serviceFees =
            serviceFees +
            parseFloat(item?.platformServiceFee ? item?.platformServiceFee : 0);
          priceToConsumer = priceToConsumer + parseFloat(item.priceToConsumer);
        });
      }

      return parseFloat(priceToConsumer).toFixed(2);
    }
  };

  const calculateUsersReceiveTotalPrice = () => {
    return parseFloat(
      parseFloat(bookingInfo?.totalPriceToConsumer) -
        parseFloat(bookingInfo?.totalPlatformServiceFee) -
        parseFloat(bookingInfo?.totalStripePaymentFee),
    ).toFixed(2);
  };

  const calculateServiceFees = () => {
    let serviceFees = 0;

    if (bookingInfo && bookingInfo?.ticketsBought?.length) {
      bookingInfo?.ticketsBought.forEach((item) => {
        if (item.absorbServiceFee == false) {
          // serviceFees = serviceFees + (parseFloat((item?.platformServiceFee) ? item?.platformServiceFee : 0) * parseFloat(item?.bookingQty))
          serviceFees =
            serviceFees +
            parseFloat(item?.platformServiceFee ? item?.platformServiceFee : 0);
        }
      });
    }

    if (bookingInfo && bookingInfo?.addonsBought?.length) {
      bookingInfo?.addonsBought.forEach((item) => {
        // serviceFees = serviceFees + (parseFloat(item?.platformServiceFee ? item?.platformServiceFee : 0) * parseFloat(item?.bookingQty))
        serviceFees =
          serviceFees +
          parseFloat(item?.platformServiceFee ? item?.platformServiceFee : 0);
      });
    }

    return parseFloat(serviceFees).toFixed(2);
  };

  const calculatePayoutDetailPlatformFee = () => {
    let serviceFeeQty = 0;
    let serviceFeesAmount = 0;

    if (bookingInfo && bookingInfo?.ticketsBought?.length) {
      bookingInfo?.ticketsBought.forEach((item) => {
        // if (item?.absorbPlatformServiceFee !== undefined && item?.absorbPlatformServiceFee === false && (parseFloat((item?.platformServiceFee) ? item?.platformServiceFee : 0)) > 0) {
        if (
          parseFloat(item?.platformServiceFee ? item?.platformServiceFee : 0) >
          0
        ) {
          serviceFeeQty = serviceFeeQty + parseFloat(item?.bookingQty);
          serviceFeesAmount =
            serviceFeesAmount +
            parseFloat(item?.platformServiceFee ? item?.platformServiceFee : 0);
        }
      });
    }

    if (bookingInfo && bookingInfo?.addonsBought?.length) {
      bookingInfo?.addonsBought.forEach((item) => {
        if (
          parseFloat(item?.platformServiceFee ? item?.platformServiceFee : 0) >
          0
        ) {
          serviceFeeQty = serviceFeeQty + parseFloat(item?.bookingQty);
          serviceFeesAmount =
            serviceFeesAmount +
            parseFloat(item?.platformServiceFee ? item?.platformServiceFee : 0);
        }
      });
    }

    return {
      serviceFeeQty: parseFloat(serviceFeeQty),
      serviceFeesAmount: parseFloat(serviceFeesAmount).toFixed(2),
    };
  };

  const calculatePaymentServiceFees = () => {
    if (bookingInfo?.totalPaymentServiceFee) {
      return parseFloat(bookingInfo?.totalPaymentServiceFee).toFixed(2);
    }
    return parseFloat(0).toFixed(2);
  };

  const getConsumerInfo = () => {
    let consumerDetails = {};

    if (bookingInfo) {
      consumerDetails = bookingInfo?.consumer_detail;
    }

    return consumerDetails;
  };

  const handleDelete = async () => {
    setDelDialogOpen(false);
    if (bookingInfo) {
      const body = {
        bookingId: bookingInfo?.bookingId,
        eventScheduleId: bookingInfo?.eventScheduleId,
        type: "remove",
        isPackage: bookingInfo?.isPackage,
        participantId: bookingInfo?.studentId,
        isRefundApplicable: true,
      };

      const config = {
          method: "post",
          url: `${getUrlForBookings()}cancelEventBooking`, // condation is not checked for event
          data: body,
      };
      dispatch(setGlobalLoading(true));
      const request = await axiosInstance(config);
      dispatch(setGlobalLoading(false));
      if (request.status === 200) {
          if (request.data.statusCode === 200) {
              addSuccessToast("Booking successfully cancelled!");
              await fetchBookingsDetails();
          } else {
              addErrorToast(request.data.message);
          }
      }
    }
  };

  const getPaymentStatus = () => {
    let paymentStatus = bookingInfo?.paymentStatus;
    // if ((bookingInfo?.paymentStatus == "Paid" || bookingInfo?.paymentStatus == "Free") && bookingInfo.paymentMethod == "NA" && parseInt(bookingInfo.amount) <= 0) {
    //     paymentStatus = 'Free';
    // }
    var displayContent = (
      <button
        className={"h-8 bg-black rounded-lg ml-4 px-3"}
        onClick={() => null}
      >
        <p className={"font-bold text-sm text-white text-center"}>
          {paymentStatus}
        </p>
      </button>
    );
    if (
      bookingInfo?.status == "Cancelled" &&
      (bookingInfo?.paymentStatus == "Unpaid" ||
        bookingInfo?.paymentStatus == "Not-refunded") &&
      bookingInfo.paymentMode != "Online"
    ) {
      displayContent = (
        <span>
          {displayContent}
          <br></br>{" "}
          <span className="ml-4 text-gray-600">
            {t("bookings.customerNeverPaidForIt")}
          </span>
        </span>
      );
    } else if (
      bookingInfo?.status == "Cancelled" &&
      bookingInfo?.paymentStatus == "Not-refunded" &&
      bookingInfo.paymentMode == "NA" &&
      parseInt(bookingInfo.amount) <= 0
    ) {
      displayContent = (
        <span>
          {displayContent}
          <br></br>{" "}
          <span className="ml-4 text-gray-600">
            {t("bookings.itWasAFreeService")}
          </span>
        </span>
      );
    }

    return displayContent;
  };

  const getPaymentMethod = () => {
    if (bookingInfo?.paymentMethod && bookingInfo?.paymentMethod !== "NA") {
      return Object.keys(displayAvailablePaymentMethods).indexOf(
        bookingInfo?.paymentMethod,
      ) >= 0
        ? displayAvailablePaymentMethods[bookingInfo?.paymentMethod]
        : t("bookings.unknown");
    } /* else if (bookingInfo?.paymentStatus == "Unpaid" && bookingInfo.paymentMethod == "NA" && bookingInfo.paymentMode != "Online" && parseInt(bookingInfo.amount) > 0) {
            return 'pay at venue';
        } else if ((bookingInfo?.paymentStatus == "Paid" || bookingInfo?.paymentStatus == "Free") && bookingInfo.paymentMethod == "NA" && parseInt(bookingInfo.amount) <= 0) {
            //return 'Free';
            return 'Not Applicable';
        } */
    return t("bookings.unknown");
  };


  return (
    <TwMainLayout
      headTitle={`Booking Details`}
      breadcrumbs={[
        {
          title: t("pageTitle.myEvents"),
          onClick: () => {
            navigate("/myschedule");
          },
        },
        {
          title: bookingInfo?.event_detail?.eventName
            ? bookingInfo?.event_detail?.eventName
            : bookingInfo?.eventName || "",
          onClick: () => {
            navigate(-1);
          },
        },
        { title: `${bookingInfo?.bookingId}` },
      ]}
      headActions={[
        <ActionPopover
          bookingDetails={bookingInfo}
          handleUpdate={fetchBookingsDetails}
        />,
        <TwButton
          variant={"secondary"}
          className="sm:min-w-32 md:py-3.5 xl:py-3.5 md:px-6 !rounded-lg"
          disabled={
            bookingInfo?.status == "Cancelled"
              ? true
              : moment(
                  bookingInfo?.eventScheduleId &&
                    bookingInfo?.event_schedule_detail
                    ? bookingInfo?.event_schedule_detail?.eventDate
                    : bookingInfo?.event_schedule_detail?.eventDate,
                )
                  .subtract({ hours: 0 })
                  .isBefore()
          }
          onClick={() => setDelDialogOpen(true)}
        >
          {t("bookings.cancelBooking")}
        </TwButton>,
      ]}
      children={
        <TwContainer className="">
          <div className="flex flex-col gap-6 w-full">
            <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
              <div className="flex">
                <p className="text-xl sm:text-3xl font-bold">
                  {t("bookings.bookingId")}
                </p>
                <p className="text-gray-500 text-xl sm:text-3xl font-bold">
                  : {bookingInfo?.bookingId}
                </p>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.bookingStatus")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span
                    style={{
                      ...(bookingInfo?.status &&
                      bookingInfo?.status === "Cancelled"
                        ? { color: "#FF4040" }
                        : {}),
                    }}
                  >
                    {bookingInfo?.status}
                  </span>
                </span>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.bookingDate")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="">
                    {moment(bookingInfo?.bookingDate).format("DD-MM-YYYY")}
                  </span>
                </span>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.cancellationDate")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="">
                    {bookingInfo?.status?.toLowerCase() === "cancelled"
                      ? moment(bookingInfo?.cancellationDate).format(
                          "DD-MM-YYYY",
                        )
                      : "Not Applicable"}
                  </span>
                </span>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.paymentStatus")}
                </p>
                <span className="text-base">
                  <span>:</span>
                  {getPaymentStatus(bookingInfo)}
                  {/* <button
                                        className={
                                            "h-8 bg-primary rounded-lg ml-4 px-3"
                                        }
                                        onClick={() => null}
                                        >
                                        <p className={"font-bold text-sm text-white text-center"}>
                                            {bookingInfo?.paymentStatus}
                                        </p>
                                    </button> */}
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
              <div className="flex">
                <p className="text-xl sm:text-3xl font-bold">
                  {t("bookings.customerDetails")}
                </p>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("inputFieldsTitle.fullName")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="">
                    {getConsumerInfo()?.fullName
                      ? getConsumerInfo()?.fullName
                      : t("bookings.unknown")}
                  </span>
                </span>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("inputFieldsTitle.email")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="text-indigo-bz">
                    {getConsumerInfo()?.email
                      ? getConsumerInfo()?.email
                      : t("bookings.unknown")}
                  </span>
                </span>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("inputFieldsTitle.mobileNumber")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="">
                    {getConsumerInfo()?.username
                      ? "" + getConsumerInfo()?.username
                      : t("bookings.unknown")}
                  </span>
                </span>
              </div>
              {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">City</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{bookingInfo?.event_schedule_detail?.location?.city}</span>
                                </span>
                            </div> */}
            </div>
            <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
              <div className="flex">
                <p className="text-xl sm:text-3xl font-bold">
                  {t("bookings.purchaseDetails")}
                </p>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.activityBooked")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="">
                    {bookingInfo?.event_detail?.eventName
                      ? bookingInfo?.event_detail?.eventName
                      : bookingInfo?.eventName || ""}
                  </span>
                </span>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.activityStatus")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span
                    style={{
                      ...(bookingInfo?.event_schedule_detail &&
                      bookingInfo?.event_schedule_detail?.eventStatus ===
                        "Cancelled"
                        ? { color: "#FF4040" }
                        : {}),
                    }}
                  >
                    {bookingInfo?.event_schedule_detail?.eventStatus
                      ? bookingInfo?.event_schedule_detail?.eventStatus ===
                        "Cancelled"
                        ? "This event is cancelled"
                        : bookingInfo?.event_schedule_detail?.eventStatus
                      : t("bookings.unknown")}
                  </span>
                </span>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.activityDate")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="text-indigo-bz">
                    {moment(
                      bookingInfo?.event_schedule_detail?.eventDate,
                    ).format("DD-MM-YYYY")}
                  </span>
                </span>
              </div>
              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.ticketsBought")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="">{calculateBoughtTickets()}</span>
                </span>
              </div>

              {bookingInfo?.ticketsBought?.length
                ? bookingInfo?.ticketsBought?.map((ticketInfo) => (
                    <div className="flex">
                      <p className="text-base min-w-36 w-36 sm:w-52 pl-5">
                        {ticketInfo?.ticketType}{" "}
                        {ticketInfo?.isComplementaryTicket &&
                        ticketInfo?.isComplementaryTicket == true ? (
                          <span className="text-xs">
                            <br />
                            {t("bookings.complementaryTicket")}
                          </span>
                        ) : (
                          ""
                        )}
                      </p>
                      <span className="text-base flex gap-5">
                        <span>:</span>
                        {/* <span className="">€{parseFloat(ticketInfo?.bookingQty * (parseFloat(parseFloat(ticketInfo?.ticketPrice ? ticketInfo?.ticketPrice : 0) + parseFloat(((ticketInfo?.absorbServiceFee == false) ? (ticketInfo?.platformServiceFee / ticketInfo?.bookingQty) : 0))))).toFixed(2)} <span className="text-gray-600">{`(${ticketInfo?.bookingQty} X €${parseFloat(parseFloat(ticketInfo?.ticketPrice ? ticketInfo?.ticketPrice : 0) + parseFloat(((ticketInfo?.absorbServiceFee == false) ? (ticketInfo?.platformServiceFee / ticketInfo?.bookingQty) : 0))).toFixed(2)})`}</span></span> */}
                        <span className="">
                          €{parseFloat(ticketInfo?.priceToConsumer).toFixed(2)}{" "}
                          <span className="text-gray-600">{`(${ticketInfo?.bookingQty} X €${parseFloat(parseFloat(ticketInfo?.priceToConsumer ? ticketInfo?.priceToConsumer : 0) / parseFloat(ticketInfo?.bookingQty)).toFixed(2)})`}</span>
                        </span>
                      </span>
                    </div>
                  ))
                : null}

              {/* Dietary preferences per ticket */}
              {(() => {
                const dietaryItems = [];
                (bookingInfo?.tickets || []).forEach((ticket, tIdx) => {
                  (ticket?.includedAddons || []).forEach((addon) => {
                    if (addon?.dietaryPreference) {
                      dietaryItems.push({
                        ticketType: ticket?.ticketType || "",
                        ticketNum: tIdx + 1,
                        addonName: addon?.addonName || "",
                        preference: addon.dietaryPreference,
                      });
                    }
                  });
                });
                if (dietaryItems.length === 0) return null;
                return (
                  <>
                    <div className="flex">
                      <p className="text-base min-w-36 w-36 sm:w-52">
                        {t("bookings.dietaryPreferences", "Dietary Preferences")}
                      </p>
                    </div>
                    {dietaryItems.map((item, i) => (
                      <div className="flex" key={i}>
                        <p className="text-base min-w-36 w-36 sm:w-52 pl-5 text-gray-600">
                          {item.ticketType} #{item.ticketNum} — {item.addonName}
                        </p>
                        <span className="text-base flex gap-5">
                          <span>:</span>
                          <span>{item.preference}</span>
                        </span>
                      </div>
                    ))}
                  </>
                );
              })()}

              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.addonsBought")}
                </p>
                <span className="text-base flex gap-5">
                  <span>:</span>
                  <span className="">{calculateBoughtAddons()}</span>
                </span>
              </div>

              {bookingInfo?.addonsBought?.length
                ? bookingInfo?.addonsBought?.map((addonInfo) => (
                    <div className="flex">
                      <p className="text-base min-w-36 w-36 sm:w-52 pl-5">
                        {addonInfo?.addonName}
                      </p>
                      <span className="text-base flex gap-5">
                        <span>:</span>
                        {/* <span className="">€{parseFloat(addonInfo?.bookingQty * (parseFloat(parseFloat(addonInfo?.addonsPrice ? addonInfo?.addonsPrice : 0) + parseFloat(addonInfo?.platformServiceFee)))).toFixed(2)} <span className="text-gray-600"> {`(${addonInfo?.bookingQty} X €${parseFloat(parseFloat(addonInfo?.addonsPrice ? addonInfo?.addonsPrice : 0) + parseFloat(addonInfo?.platformServiceFee)).toFixed(2)})`}</span></span> */}
                        <span className="">
                          €{parseFloat(addonInfo?.priceToConsumer).toFixed(2)}{" "}
                          <span className="text-gray-600">{`(${addonInfo?.bookingQty} X €${parseFloat(parseFloat(addonInfo?.priceToConsumer ? addonInfo?.priceToConsumer : 0) / parseFloat(addonInfo?.bookingQty)).toFixed(2)})`}</span>
                        </span>
                      </span>
                    </div>
                  ))
                : null}

              {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">{t("bookings.paymentProcessingFee")}</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">€{calculatePaymentServiceFees()}</span>
                                </span>
                            </div> */}

              <div className="flex">
                <p className="text-base min-w-36 w-36 sm:w-52">
                  {t("bookings.paymentMethod")}
                </p>
                <span className="text-base flex gap-5 capitalize">
                  <span>:</span>
                  {/* <span className="">{bookingInfo?.paymentMethod && bookingInfo?.paymentMethod !== 'NA' ? bookingInfo?.paymentMethod : t("bookings.unknown")}</span> */}
                  <span className=""> {getPaymentMethod()}</span>
                </span>
              </div>

              <div className="flex">
                <div className="flex py-1 rounded bg-zinc-300">
                  <p className="text-base min-w-36 w-36 sm:w-52 px-3">
                    {t("bookings.totalAmountPaid")}
                  </p>
                  <span className="text-base flex gap-5 pr-3">
                    <span>:</span>
                    <span className="">
                      €{calculateTotalPrice()}{" "}
                      <span className="text-gray-600">
                        {t("bookings.includingVATFee")}
                      </span>
                    </span>
                  </span>
                </div>
              </div>

              {bookingInfo?.status?.toLowerCase() === "cancelled" &&
              bookingInfo?.cancellationDetail?.original_amount !== undefined ? (
                <>
                  <div className="flex">
                    <p className="text-xl sm:text-3xl font-bold">
                      {t("bookings.yourRefundDetails")}
                    </p>
                  </div>

                  <div className="flex">
                    <p className="text-base min-w-36 w-36 sm:w-52">
                      {t("bookings.amountCustomerPaid")}
                    </p>
                    <span className="text-base flex gap-5">
                      <span>:</span>
                      <span className="">€{parseFloat(bookingInfo?.cancellationDetail?.original_amount).toFixed(2)}</span>
                    </span>
                  </div>

                  <div className="flex">
                    <p className="text-base min-w-36 w-36 sm:w-52">
                      {t("bookings.yourCancellationFee")}
                    </p>
                    <span className="text-base flex gap-5">
                      <span>:</span>
                      {/* <span className="text-bz-status-red">- €{calculateServiceFees() + ` (${calculateBoughtTickets()} X €${parseFloat(calculateServiceFees() / calculateBoughtTickets()).toFixed(2)})`}</span> */}
                      <span className="text-bz-status-red">
                        - €
                        {parseFloat(bookingInfo?.cancellationDetail?.cancellation_fee).toFixed(2)}
                      </span>
                    </span>
                  </div>

                  <div className="flex">
                    <div className="flex py-1 rounded bg-zinc-300">
                      <p className="text-base min-w-36 w-36 sm:w-52 px-3">
                        {t("bookings.expectedRefund")}
                      </p>
                      <span className="text-base flex gap-5 pr-3">
                        <span>:</span>
                        <span className="">
                          €{parseFloat(bookingInfo?.cancellationDetail?.refunded_amount).toFixed(2)}{" "}
                          {/* <span className="text-gray-600">
                            {t("bookings.beforePaymentProcessingFeeMsg")}
                          </span> */}
                        </span>
                      </span>
                    </div>
                  </div>

                  {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">What you get</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">€{calculateUsersReceiveTotalPrice()} </span>
                                </span>
                            </div> */}
                </>
              ) : (
                <>
                  <div className="flex">
                    <p className="text-xl sm:text-3xl font-bold">
                      {t("bookings.yourPayoutDetails")}
                    </p>
                  </div>

                  <div className="flex">
                    <p className="text-base min-w-36 w-36 sm:w-52">
                      {t("bookings.amountCustomerPaid")}
                    </p>
                    <span className="text-base flex gap-5">
                      <span>:</span>
                      <span className="">€{calculateTotalPrice()}</span>
                    </span>
                  </div>

                  <div className="flex">
                    <p className="text-base min-w-36 w-36 sm:w-52">
                      {t("bookings.platformServiceFee")}
                    </p>
                    <span className="text-base flex gap-5">
                      <span>:</span>
                      {/* <span className="text-bz-status-red">- €{calculateServiceFees() + ` (${calculateBoughtTickets()} X €${parseFloat(calculateServiceFees() / calculateBoughtTickets()).toFixed(2)})`}</span> */}
                      <span className="text-bz-status-red">
                        - €
                        {calculatePayoutDetailPlatformFee().serviceFeesAmount +
                          ` (${calculatePayoutDetailPlatformFee().serviceFeeQty} X €${calculatePayoutDetailPlatformFee().serviceFeesAmount > 0 ? parseFloat(calculatePayoutDetailPlatformFee().serviceFeesAmount / calculatePayoutDetailPlatformFee().serviceFeeQty).toFixed(2) : 0})`}
                      </span>
                    </span>
                  </div>

                  {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">{t("bookings.paymentProcessingFee")}</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="text-bz-status-red">- €{calculatePaymentServiceFees()}</span>
                                </span>
                            </div> */}

                  <div className="flex">
                    <div className="flex py-1 rounded bg-zinc-300">
                      <p className="text-base min-w-36 w-36 sm:w-52 px-3">
                        {t("bookings.expectedPayout")}
                      </p>
                      <span className="text-base flex gap-5 pr-3">
                        <span>:</span>
                        <span className="">
                          €{calculateUsersReceiveTotalPrice()}{" "}
                          <span className="text-gray-600">
                            {t("bookings.beforePaymentProcessingFeeMsg")}
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>

                  {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">What you get</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">€{calculateUsersReceiveTotalPrice()} </span>
                                </span>
                            </div> */}
                </>
              )}
            </div>
          </div>

          <DeleteDialog
            open={delDialogOpen}
            title={t("bookings.warning")}
            // message={"Are you sure you want to cancel this booking?"}
            message={t("bookings.cancelBookingMsg")}
            type={""}
            handleClose={() => setDelDialogOpen(false)}
            handleDelete={() => handleDelete()}
          />
        </TwContainer>
      }
    />
  );
}
